import { inject, Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ProjectsService } from '../projects/projects.service';
import { OrdersService } from './orders.service';
import { OrderResolved } from '../shared/models/order-resolved';

@Injectable({
  providedIn: 'root'
})
export class OrderResolver {
  private projectsService = inject(ProjectsService);
  private ordersService = inject(OrdersService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<OrderResolved> {
    const project = route.paramMap.get('project') ?? '';
    const orderId = route.paramMap.get('order') ?? '';

    return this.projectsService
      .selectProject(project)
      .pipe(switchMap((projectSelectOk) => this.getOrder(projectSelectOk, orderId)));
  }

  getOrder(selectWdOk: boolean, orderId: string): Observable<OrderResolved> {
    if (!selectWdOk) {
      return of({
        order: undefined,
        orderId: orderId,
        error: new Error(`project not selectable`)
      });
    }
    return this.ordersService.getOnlineOrder(orderId).pipe(
      map((order) => ({ order: order, orderId: orderId })),
      catchError((err) =>
        of({
          order: undefined,
          orderId: orderId,
          error: err
        })
      )
    );
  }
}
